import angular from 'angular';
import referralExistingClientSearch from './referralExistingClientSearch';

export default angular
  .module('components.referralExistingClientSearch', [])
  .component('referralExistingClientSearch', referralExistingClientSearch).name;
